import { LangService } from './../../services/lang.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from '../../services/util.service';
import { RestService } from '../../services/rest.service';
import { LoadingController, ModalController, NavController, Platform, PopoverController, ToastController } from '@ionic/angular';
import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { SwiperComponent } from 'swiper/angular';
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, SwiperOptions } from 'swiper';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterComponent } from 'src/app/popover/filter/filter.component';
import { Location } from '@angular/common';
import { VariableNavBarService } from '../../services/variable-nav-bar.service';
import { SearchLouderbandComponent } from '../../components/search-louderband/search-louderband.component';

// Pixel library importing
import { PixelService } from 'ngx-pixel';
import { forkJoin, pipe } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { PendingPayLoginService } from 'src/app/services/pending-pay-login.service';
import { Capacitor } from '@capacitor/core';
import { Auth, UserCredential } from '@angular/fire/auth';
import { OAuthProvider, signInWithPopup } from 'firebase/auth';
import { SignInWithApple, SignInWithAppleOptions, SignInWithAppleResponse } from '@capacitor-community/apple-sign-in';
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { Share } from '@capacitor/share';
import { TrackingProvider } from 'src/app/services/tracking';
import { AnalyticsType } from 'src/app/services/types-t';

// install Swiper modules
SwiperCore.use([Navigation, Pagination]);

@Component({
  selector: 'app-courses',
  templateUrl: './courses.page.html',
  styleUrls: ['./courses.page.scss'],
})
export class CoursesPage implements OnInit, AfterContentChecked {
  hasTranslation: boolean = true;
  browserLanguage: string;
  isMobile: boolean = false;
  isMacOS: boolean = false;
  @ViewChild('slidesCourse2') swiper: SwiperComponent;
  @ViewChild('appSearchLouderband') searchBar: SearchLouderbandComponent;
  allCoursesOriginal: any[] = [];
  allCoursesOriginalNew: any[] = [];

  // Define the base Swiper configuration
  baseSwiperOptions: SwiperOptions = {
    initialSlide: 0,
    navigation: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    allowSlidePrev: true,
    allowSlideNext: true,
    slideToClickedSlide: true
  };

  // Create specific configurations by extending the base configuration
  slidesCourse2T: SwiperOptions = {
    ...this.baseSwiperOptions,
    slidesPerView: 3.5,
    spaceBetween: 40
  };

  slidesCourse5M: SwiperOptions = {
    ...this.baseSwiperOptions,
    slidesPerView: 1,
    spaceBetween: 16
  };

  slidesCourse2TM: SwiperOptions = {
    ...this.baseSwiperOptions,
    slidesPerView: 1,
    spaceBetween: 12
  };

  slidesCourse5: SwiperOptions = {
    ...this.baseSwiperOptions,
    slidesPerView: 3.5,
    spaceBetween: 15,
    centeredSlides: false
  };

  slidesCourse5F: SwiperOptions = {
    ...this.baseSwiperOptions,
    slidesPerView: 2.6,
    spaceBetween: 1,
    centeredSlides: false,
    centeredSlidesBounds: false
  };

  slidesCourse6F: SwiperOptions = {
    ...this.baseSwiperOptions,
    slidesPerView: 2.6,
    spaceBetween: 1,
    centeredSlides: false,
    centeredSlidesBounds: false,
    width: 1400
  };

  comingSoonCourses: SwiperOptions = {
    ...this.baseSwiperOptions,
    slidesPerView: 1.5,
    spaceBetween: 50,
    centeredSlides: false,
    centeredSlidesBounds: false,
    width: 1400
  };

  comingSoonCoursesMobile: SwiperOptions = {
    ...this.baseSwiperOptions,
    slidesPerView: 1.4,
    spaceBetween: 20,
    centeredSlidesBounds: true
  };



  banners: any[] = [];
  user: any;
  //videosCourse: any[] = [];
  //videosCourseHelp: any[] = [];
  //helpLoop2: boolean;
  //helpLoop: boolean;
  //canalesData: any[] = [];
  courses: any[] = [];
  allCategories: any[] = [];
  allCourses: any[] = [];
  allCoursesNew: any[] = [];
  RespallCoursesType: any[] = [];
  allCoursesByCat: any[] = [];
  loadMostWanted: boolean;
  helpFocus: boolean;
  showOverSearch: boolean;
  searchTop: string;
  auxLoading: any;
  coursesWatch: any[] = [];
  coursesPurchased: any[] = [];
  loadAll: boolean;
  filterType: any = 3;
  showF: boolean;
  categories: any[] = [];
  langH: any;
  courserByCat: any[] = [];
  optionsFilter: any[] = [];
  titleFilter: any;
  totalCourses: number = 0;
  maxCategoriesToLoadPerScroll = 2;
  totalCategoriesLoaded = 0;
  loadingMoreCourses = false;
  availableSubscriptions: any;
  subscriptionId: any;
  filterCourseTypeVariable: any
  workshops: any[] = [];
  comingsoon: any[] = [];
  comingsoon2: any[] = [];
  bandWoks: boolean = false;
  showModalLogin: boolean;
  userSubscriptions: any[];
  profile: any;
  worshopId: any;
  promotion: any;

  constructor(
    public rest: RestService,
    public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public modalController: ModalController,
    public util: UtilService,
    public platform: Platform,
    private cdRef: ChangeDetectorRef,
    public domSanitizer: DomSanitizer,
    private translate: TranslateService,
    private route: ActivatedRoute,
    public langService: LangService,
    public popoverCtrl: PopoverController,
    private location: Location,
    public variableNavBarService: VariableNavBarService,
    private pixel: PixelService,
    private elementRef: ElementRef,
    private saveRouter: Router,
    public pendingPayLoginService: PendingPayLoginService,
    private auth: Auth,
    public toastCtrl: ToastController,
    private trackingProvider: TrackingProvider
  ) {
    //console.log('Platform:', this.platform.platforms());
    if (this.platform.is('android') || this.platform.is('ios') || this.platform.is('mobile') || this.platform.is('mobileweb')) {
      this.isMobile = true;
    }
    this.rest.getStorage('user').then((val) => {
      this.user = val;
    });
    this.langService.getLanguajeStorage().then((val => {
      if (val) {

        //console.log('>>>XXX1-home', val);
        this.reloadTrans(val);
      } else {
        //console.log('>>>XXX3');
        this.reloadTrans('es');
      }
    })).catch((err) => {
      //console.log('>>>XXX5');
      this.reloadTrans('es');
    });
    this.isMacOS = (navigator.userAgent.indexOf('Macintosh') > 0 && navigator.userAgent.indexOf('Safari') > 0 && navigator.userAgent.indexOf('Chrome') <= 0) ? true : false;
    this.initBanners();
    this.getAvailableSubscriptions();
  }

  private reloadTrans(lang) {
    this.translate.use(lang);
    this.langService.setTranslateLanguage(lang);
    this.langH = lang;
  }

  ngAfterContentChecked() {
    if (this.swiper) {
      this.swiper.updateSwiper({});
    }

    this.cdRef.detectChanges();
  }

  initBanners() {
    this.banners = [];
    this.getBanners('course_results');
  }

  goToWorkshops(val) {
    console.log(val);
    this.navCtrl.navigateForward('workshops/' + val.id);
  }


  getBanners(section) {

    const default_banner = 'assets/imagen/img_bg_top.png';

    this.banners.push({ 'banner_section': section, 'banner_image': default_banner });

    let apiHelp = 'banners';

    if (!this.util.token) {
      apiHelp += '/guest';
    }

    if (section) {
      this.rest._get(apiHelp + '/' + section).subscribe(async (response) => {

        var banner: any = response.body;

        //console.log('Banner for section ' + section, banner.data.banner);

        if (banner.data.banner) {
          banner.data.banner.forEach((b) => {
            this.banners.push(b);
          });
          // this.outData.emit({ banners: this.banners });
          // console.log('Banners: ', this.banners);
        }
      }, (error) => {
        console.log('Error getting banner: ', error);
      });
    }
  }

  async ngOnInit() {
    await this.listWorkshops();
    await this.listComingSoon();
    this.variableNavBarService.updateVarOnCoursePage();
    this.filterType = this.route.snapshot.queryParams['type'] || 3;
    if (this.user) {
      this.getCategories();
    } else {
      this.rest.getStorage('user').then(async (val) => {
        this.user = val;


        //console.log(val);

      });
      setTimeout(() => {
        this.getCategories();
      }, 400);
    }
  }

  listWorkshops() {
    this.rest._get('courses/workshops')
      .subscribe(response => {
        const res: any = response.body;
        this.workshops = res.courses;

      }, (ress) => {
        console.log(ress);
      });
  }

  listComingSoon() {
    this.rest._get('courses/comingsoon')
      .subscribe(response => {
        const res: any = response.body;
        this.comingsoon = res.courses;
      }, (ress) => {
        console.log(ress);
      });
  }

  ionViewDidEnter() {
    this.variableNavBarService.updateVarOnCoursePage();

    this.promotion = localStorage.getItem("promotion");

    if (this.user) {
      this.initData();
    } else {
      this.rest.getStorage('user').then((val) => {
        this.user = val;
        //console.log(val);

      });
      setTimeout(() => {
        this.initData();
      }, 400);
    }
  }

  private getCategories() {
    this.rest._getLocal('https://api.louderband.com/api/instruments?fields=instrument_id%2C%20name&per-page=0&sort=name').subscribe(async (response) => {
      const auxResp: any = JSON.parse(response.body);
      //console.log(auxResp);
      this.categories = auxResp.items;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  async initData() {
    this.auxLoading = await this.loadingCtrl.create({});
    this.auxLoading.present();
    this.getSubscriptions();
    this.platform.ready().then(() => {
      Promise.all([
        // this.loadSchedules(),
        //this.getVideos(),
        this.myCourses(),
        //this.getCanales(),
        this.loadAllCourses()
      ]).then(() => {
        /*setTimeout(() => {
          this.route.queryParams.subscribe(params => {
            //console.log('queryParams', params);
            if (params['type']) {
              this.filterCourses(params['type']);
            }
          });
        }, 3000);*/
        if (this.totalCategoriesLoaded > 0) {
          this.auxLoading.dismiss();
        }
      })
        .catch((err) => {
          console.error(err);
          this.auxLoading.dismiss();
        });
    });
  }

  //TODO: Para que se usa este  ?
  /*getVideos() {
    let apiHelp = '';
    if (this.user != null && (this.user.premium === 'S' || 'N')) {
      apiHelp = 'courses/featured';
    } else {
      apiHelp = 'courses/guest/featured';
    }
    return this.rest._get(apiHelp).subscribe(response => {
      console.log('###--getVideos--###');
      const res: any = response.body;
      const videosCourseAux = res.data.courses;
      console.log(this.videosCourse);
      this.videosCourseHelp = [];
      this.videosCourse = [];
      setTimeout(() => {
        window.localStorage.setItem('oldUser', '1');
      }, 1000);
      for (const iterator of videosCourseAux) {
        if (iterator.featured_type == 'super') {
          this.videosCourseHelp.push(iterator);
        }
        if (iterator.featured_type == 'standard') {
          this.videosCourse.push(iterator);
        }
      }

      if (this.videosCourse.length > 1) {
        this.slidesCourse2.loop = false;
        this.helpLoop = true;
        this.slidesCourse2.autoplay = true;
        setTimeout(() => {
          // this.slidesCourse2.startAutoplay();
        }, 4000);
        this.slidesCourse2.spaceBetween = 20;
        this.slidesCourse2.centeredSlides = true;
        this.slidesCourse2.slidesPerView = 1.40;
      } else {
        this.helpLoop2 = false;
        this.slidesCourse2.loop = false;
        this.slidesCourse2.spaceBetween = 10;
        this.slidesCourse2.centeredSlides = true;
        this.slidesCourse2.slidesPerView = 1;
      }

    }, (res) => {
      console.log(res);
    });

  }*/

  /*getCanales() {
    let apiHelp = '';
    if (this.user != null && (this.user.premium === 'S' || 'N')) {
      apiHelp = 'channels';
    } else {
      apiHelp = 'channels/guest';
    }
    this.canalesData = [];
    return this.rest._get(apiHelp).subscribe(response => {
      console.log('###--channels--###');
      const res: any = response.body;
      this.canalesData = res.data.channels;
      console.log(this.canalesData);
    }, (reee) => {
      console.log(reee);
    });
  }*/


  myCourses() {
    setTimeout(() => {
      if (!this.user) {
        return true;
      }
      return this.rest._get('courses/purchaseds').subscribe(response => {
        //console.log('###--getVideos--###');
        const res: any = response.body;
        this.coursesPurchased = res.data.courses_purchaseds;
        this.coursesWatch = res.data.courses_purchaseds.filter((course) => {
          return course.continue_watching == true;
        });
      }, (ress) => {
        console.log(ress);
      });
    }, 400);

  }

  //TODOS LOS CURSOS
  loadAllCourses() {
    return this.rest._get('courses/categories')
      .subscribe(response => {
        const res: any = response.body;
        this.optionsFilter = res.data.categories;
        this.allCategories = res.data;

        if (this.totalCategoriesLoaded === 0) {
          this.loadCoursesLazy();
          this.loadCoursesAll();
        }
      }, (ress) => {
        console.log(ress);
      });
  }

  loadCoursesLazy() {
    const totalToLoad = Math.min(this.maxCategoriesToLoadPerScroll, this.optionsFilter.length - this.totalCategoriesLoaded);
    forkJoin(this.optionsFilter.slice(this.totalCategoriesLoaded, this.totalCategoriesLoaded + totalToLoad).map((category) => {
      let apiHelp = '';
      if (this.user != null && (this.user.premium === 'S' || 'N')) {
        apiHelp = 'courses/byCategory/';
      } else {
        apiHelp = 'courses/guest/byCategory/';
      }
      const auxFiltered = {
        category: this.langH === 'es' ? category.name : category.english_tag,
        courses: []
      };
      const auxOrig = {
        category: this.langH === 'es' ? category.name : category.english_tag,
        courses: []
      };
      this.allCourses.push(auxFiltered);
      this.allCoursesOriginal.push(auxOrig);
      return this.rest._get(apiHelp + category.category_id).pipe(
        map((response2) => {
          const res2: any = response2.body;
          let newLang = this.langService.getTranslateLanguage();
          this.browserLanguage = newLang ?? navigator.language;

             this.hasTranslation = false;  
            if (this.browserLanguage.substring(0, 2) === 'es') {
               this.hasTranslation = true;  
            }  
          res2.data.courses.forEach((course: any) => {
                
            if (course.translations && course.translations.length > 0) {
              const translation = course.translations.find(
                (t: any) => t.language.substring(0, 2) === this.browserLanguage.substring(0, 2)
              );
              if (translation && translation.title) {
                course.title = translation.title;
                course.hasTranslation = true;                
              }
            }
          });
          auxOrig.courses = res2.data.courses;
          auxFiltered.courses = this.filterInternalCourses(this.filterType, res2.data.courses);
          return true;
        })
      );
    }))
      .pipe(finalize(() => this.loadingMoreCourses = false))
      .subscribe(() => {
        this.auxLoading.dismiss();
        this.loadAll = true;
        this.totalCategoriesLoaded += totalToLoad;
      });
    if (!this.bandWoks) {
      let nuevoObjeto = { category: 'workshops', courses: this.workshops };
      this.allCourses.splice(2, 0, nuevoObjeto);
      this.allCoursesOriginal.splice(2, 0, nuevoObjeto);
      this.bandWoks = true;
      this.comingsoon2 = this.allCourses[2].courses
    }

  }

  loadCoursesAll() {
    this.optionsFilter.map((category) => {
      let apiHelp = '';
      if (this.user != null && (this.user.premium === 'S' || 'N')) {
        apiHelp = 'courses/byCategory/';
      } else {
        apiHelp = 'courses/guest/byCategory/';
      }
      const auxFiltered = {
        category: this.langH === 'es' ? category.name : category.english_tag,
        courses: []
      };
      const auxOrig = {
        category: this.langH === 'es' ? category.name : category.english_tag,
        courses: []
      };
      this.allCoursesNew.push(auxFiltered);
      this.allCoursesOriginalNew.push(auxOrig);
      return this.rest._get(apiHelp + category.category_id).pipe(
        map((response2) => {
          const res2: any = response2.body;

          let newLang = this.langService.getTranslateLanguage();
          this.browserLanguage = newLang ?? navigator.language;

           this.hasTranslation = false;    
          if (this.browserLanguage.substring(0, 2) === 'es') {
             this.hasTranslation = true;  
          }  
          res2.data.courses.forEach((course: any) => {
            if (course.translations && course.translations.length > 0) {
              const translation = course.translations.find(
                (t: any) => t.language.substring(0, 2) === this.browserLanguage.substring(0, 2)
              );
              if (translation && translation.title) {
                course.title = translation.title;
                course.hasTranslation = true;
              }
            }
          });
          
          auxOrig.courses = res2.data.courses;
          auxFiltered.courses = this.filterInternalCourses(this.filterType, res2.data.courses);
          return true;
        })
      ).subscribe();
    })
  }

  onScroll() {
    const element = this.elementRef.nativeElement.querySelector('#lazyLoading');
    const bounding = element.getBoundingClientRect();
    if (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      this.totalCategoriesLoaded < this.optionsFilter.length
    ) {
      setTimeout(async () => {
        if (!this.loadingMoreCourses) {
          this.loadingMoreCourses = true;
          //this.auxLoading = await this.loadingCtrl.create({});
          //this.auxLoading.present();
          this.loadCoursesLazy();
        }
      }, 100);
    } else {
      console.log('El elemento no es visible en la pantalla durante el scroll');
    }
  }


  helpLoadCourses(arraysH) {

    this.allCourses = [];
    this.totalCourses = 0;

    for (const iterator of arraysH) {
      const index = this.allCourses.map(x => x.category).indexOf(this.langH === 'es' ? iterator.category.name : iterator.category.english_tag);
      //console.log(index);
      //console.log(this.allCourses);
      if (index >= 0) {
        let auxArray: any[] = this.allCourses[index].courses;
        auxArray.push(iterator);
        this.totalCourses++;
        this.allCourses[index].courses = auxArray;
      } else {
        let aux = {
          category: this.langH === 'es' ? iterator.category.name : iterator.category.english_tag,
          courses: [iterator]
        };
        this.optionsFilter.push(iterator.category);
        this.allCourses.push(aux);
      }
    }
    //console.log(this.allCourses);
  }

  findBanner(section, mobile = false) {
    let banner = this.banners.find(e => (e.banner_section == section && e.is_mobile == mobile && (e.only_operator == (this.user?.msisdn ? true : false) && e.operator == this.user?.msisdn_provider)));
    return banner;
  }

  async viewVideo(ita) {
    //console.log(ita);
    ita.seevideo = true;
    /*
    const modal = await this.modalController.create({
      component: VideoComponent,
      componentProps: { item: ita},
      cssClass: 'modal-expand2'
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);

*/
  }

  onSwiper(ev) {

  }

  onSlideChange() {
  }

  gotoOldApp(view?) {
    //console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }

  outData2(ev) {
    //console.log(ev);
    if (ev.banners) {
      this.banners = ev.banners;
    }

    if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
      this.searchBar.clearFilters();
    }
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login');
    }

    if (ev && ev.home) {
      let url = '/home';
      this.location.go(url);
    }

    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if (ev && ev.search) {
      //console.log(ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log(ev);
      this.isMobile = ev.isMobile;
    }

    /*if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
      this.searchBar.clearFilters();
    }*/

  }

  showFilter() {
    this.showF = !this.showF;

  }
  //filtrado por categoria
  async filteryCat(category) {
    this.filterCourseTypeVariable = this.optionsFilter.find(categoryId => category === categoryId.category_id);
    let apiHelp = '';
    if (this.user != null && (this.user.premium === 'S' || 'N')) {
      apiHelp = 'courses/byCategory/';
    } else {
      apiHelp = 'courses/guest/byCategory/';
    }
    this.courserByCat = [];
    this.auxLoading = await this.loadingCtrl.create({});
    this.auxLoading.present();
    this.rest._get(apiHelp + category).subscribe(response => {
      //console.log('###--getVideos--###');
      const res: any = response.body;
      if (res.data.courses) {
        let newLang = this.langService.getTranslateLanguage();
        this.browserLanguage = newLang ?? navigator.language;

         this.hasTranslation = false;    
        if (this.browserLanguage.substring(0, 2) === 'es') {
           this.hasTranslation = true;  
        }  
        res.data.courses.forEach((course: any) => {
          if (course.translations && course.translations.length > 0) {
            const translation = course.translations.find(
              (t: any) => t.language.substring(0, 2) === this.browserLanguage.substring(0, 2)
            );
            if (translation && translation.title) {
              course.title = translation.title;
              course.hasTranslation = true;
            }
          }
        });
        this.allCoursesByCat = res.data.courses;
        const matchingCourses = this.allCoursesByCat.filter(courseByCat =>
          this.allCoursesNew.some(allc =>
            allc.category === courseByCat.category.name && allc.courses.some(allc2 => allc2.id === courseByCat.id)
          )
        );

        this.courserByCat.push(...matchingCourses);
        //   for (const courseByCat of this.allCoursesByCat) {
        //     for (const allc of this.allCoursesNew) { 
        //       if(courseByCat.category.name == allc.category ){
        //         for (const allc2 of allc.courses) { 
        //           if(courseByCat.id == allc2.id){
        //             console.log('true2');
        //             this.courserByCat.push(courseByCat);
        //           }
        //         }
        //         console.log('true');
        //       }   
        //     }      
        // }

      }

      if (this.courserByCat.length <= 0) {
        this.allCoursesNew = [];
        this.allCourses = [];
      }


      //console.log(this.courserByCat);
      this.auxLoading.dismiss();
    }, (ress) => {
      console.log(ress);
    });
  }


  getPriceOld(item) {

    if (this.platform.is('ios') && item.ios_offer_price) {
      if (item.ios_price) {
        return item.ios_price;
      } else if (item.price) {
        return item.price;
      }
    }

    if (this.platform.is('android') && item.ios_offer_price) {
      if (item.android_price) {
        return item.android_price;
      } else if (item.price) {
        return item.price;
      }
    }

    if (item.price && item.offer_price) {
      return item.price;
    }
  }

  getPrice(item: any) {

    if (this.platform.is('ios')) {
      if (item.ios_offer_price) {
        return item.ios_offer_price;
      } else if (item.offer_price) {
        return item.offer_price;
      }
    }

    if (this.platform.is('android')) {
      if (item.android_offer_price) {
        return item.android_offer_price;
      } else if (item.offer_price) {
        return item.offer_price;
      }
    }

    if (item.offer_price) {
      return item.offer_price;
    } else {
      return item.price;
    }

  }



  filterInternalCourses(type: any, courses: any[]) {
    console.log('filterInternalCourses', type, courses);
    if (type == 1) {
      return courses.filter((obj) => (!obj.has_subscription || obj.has_subscription.length < 1) && !obj.is_workshop && !obj.is_coming_soon);
    }
    if (type == 2) {
      return courses.filter((obj) => (obj.has_subscription && obj.has_subscription.length > 0) && !obj.is_workshop && !obj.is_coming_soon);
    }
    if (type == 3) {
      return courses.filter((obj) => !obj.is_workshop && !obj.is_coming_soon);
    }
    if (type == 4) {
      return courses.filter((obj) => (obj.purchased === true) && !obj.is_workshop && !obj.is_coming_soon);
    }
  }

  async getAvailableSubscriptions() {
    const loading = await this.loadingCtrl.create({});
    loading.present();


    this.rest._get('subscription/list').subscribe(async (response) => {
      const res: any = response.body;
      this.availableSubscriptions = res;
      console.log('available subscriptions', this.availableSubscriptions);
      this.subscriptionId = this.availableSubscriptions[0].id;

      console.log('available subscriptions', res);
      loading.dismiss();
    }, (error) => {
      loading.dismiss();
      console.error('error subscriptions: ', error);
    });
  }

  //aqui se filtran los cursos por etiquetas
  async filterCourses2(type) {
    this.loadCoursesAll();
    this.filterType = type;
    const load = await this.loadingCtrl.create({ duration: 1000 });
    load.present();
    if (type == 1) {
      this.allCoursesNew = this.allCoursesOriginalNew.map((catCourse) => ({
        category: catCourse.category,
        courses: catCourse.courses.filter((obj) => {
          return !obj.has_subscription || obj.has_subscription.length < 1 && !obj.is_workshop && !obj.is_coming_soon;
        })
      }));
    }
    if (type == 2) {
      this.allCoursesNew = this.allCoursesOriginalNew.map((catCourse) => ({
        category: catCourse.category,
        courses: catCourse.courses.filter((obj) => {
          return obj.has_subscription && obj.has_subscription.length > 0 && !obj.is_workshop && !obj.is_coming_soon;
        })
      }));
    }
    if (type == 3) {
      this.allCoursesNew = this.allCoursesOriginalNew.map((catCourse) => ({
        category: catCourse.category,
        courses: catCourse.courses.filter((obj) => {
          return !obj.is_workshop && !obj.is_coming_soon;
        })
      }));
      // this.allCoursesNew = this.allCoursesOriginalNew;
    }
    if (type == 4) {
      this.allCoursesNew = this.allCoursesOriginalNew.map((catCourse) => ({
        category: catCourse.category,
        courses: catCourse.courses.filter((obj) => {
          return obj.purchased == true && !obj.is_workshop && !obj.is_coming_soon;
        })
      }));
    }
    if (this.filterCourseTypeVariable != null) {
      this.filteryCat(this.filterCourseTypeVariable.category_id);
    }
  }

  async filterCourses(type) {
    this.filterCourses2(type);
    this.RespallCoursesType = type;
    this.filterType = type;
    const load = await this.loadingCtrl.create({ duration: 1000 });
    load.present();
    if (type == 1) {
      this.allCourses = this.allCoursesOriginal.map((catCourse) => ({
        category: catCourse.category,
        courses: catCourse.courses.filter((obj) => {
          return !obj.has_subscription || obj.has_subscription.length < 1 && !obj.is_workshop && !obj.is_coming_soon;
        })
      }));
    }
    if (type == 2) {
      this.allCourses = this.allCoursesOriginal.map((catCourse) => ({
        category: catCourse.category,
        courses: catCourse.courses.filter((obj) => {
          return obj.has_subscription && obj.has_subscription.length > 0 && !obj.is_workshop && !obj.is_coming_soon;
        })
      }));
    }
    if (type == 3) {

      this.allCoursesNew = this.allCoursesOriginalNew.map((catCourse) => ({
        category: catCourse.category,
        courses: catCourse.courses.filter((obj) => {
          return !obj.is_workshop && !obj.is_coming_soon;
        })
      }));

      // this.allCourses = this.allCoursesOriginal;
    }
    if (type == 4) {
      this.allCourses = this.allCoursesOriginal.map((catCourse) => ({
        category: catCourse.category,
        courses: catCourse.courses.filter((obj) => {
          return obj.purchased == true && !obj.is_workshop && !obj.is_coming_soon;
        })
      }));
    }
  }

  gotoDetail(val) {
    console.log(val);
    this.navCtrl.navigateForward('cursos/' + val.id);
  }

  gotoHome() {
    this.navCtrl.navigateBack('home');
  }

  gotoSubs() {
    this.navCtrl.navigateForward('/suscripciones');
    //this.navCtrl.navigateForward('landing/landing-page-cursos');
  }

  filterSearch(ita) {
    //console.log(ita);
    this.titleFilter = this.langH === 'es' ? ita.name : ita.english_tag;
    this.filteryCat(ita.category_id);
  }

  async closeFilter() {
    this.auxLoading = await this.loadingCtrl.create({});
    this.auxLoading.present();
    setTimeout(() => {
      this.titleFilter = null;
      this.courserByCat = [];
      this.filterCourseTypeVariable = null;
      if (this.courserByCat.length <= 0) {
        this.filterCourses(this.RespallCoursesType);
      }
    }, 300);

    setTimeout(() => {
      this.auxLoading.dismiss();
    }, 1800);
  }

  clickBanner(banner) {
    //console.log(banner);

    // Validate Android Link
    if (banner && (banner.android_url && banner.banner_target) && this.platform.is('android')) {
      window.open(banner.android_url, banner.banner_target);
      return;
    }

    // Validate iOS Link
    if (banner && (banner.ios_url && banner.banner_target) && this.platform.is('ios')) {
      window.open(banner.ios_url, banner.banner_target);
      return;
    }

    // Default Link
    if (banner && (banner.banner_url && banner.banner_target)) {
      window.open(banner.banner_url, banner.banner_target);
      return;
    }
  }

  gotoProfile(val) {
    console.log(val);
    this.navCtrl.navigateBack('perfiles/' + val.id);
  }

  async popFilter(e: Event) {
    const popover = await this.popoverCtrl.create({
      component: FilterComponent,
      componentProps: { optionsFilter: this.optionsFilter, langH: this.langH },
      mode: 'ios',
      cssClass: 'pop-filter'
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();
    //console.log(data);
    if (data && data.category) {
      this.titleFilter = this.langH === 'es' ? data.category.name : data.category.english_tag;
      this.filteryCat(data.category.category_id);
    }

  }

  getProfiles(profiles: any) {
    var profiles_label = '';
    if (profiles && profiles.length) {
      profiles_label = profiles.map((obj) => obj.description).join(', ');
    }

    return profiles_label;
  }
  modalLogin(val) {
    this.worshopId = val.id
    this.showModalLogin = true;
  }

  closeModalLogin() {
    this.showModalLogin = false;
  }

  gotoRegister() {
    this.showModalLogin = false;
    const currentRoute = 'workshops/' + this.worshopId;
    localStorage.setItem('currentRoute', currentRoute);
    this.pendingPayLoginService.payAfterLogin(true);
    this.navCtrl.navigateForward('/registro');
  }

  async loginGoogle() {
    this.showModalLogin = false;
    const result = await GoogleAuth.signIn();
    console.log(result);

    const loading = await this.loadingCtrl.create({
      message: ''
    });
    loading.present();
    this.rest._post('google/login', result).subscribe(async (response) => {
      const user: any = response.body;
      this.rest.storageSet('user', user);
      this.util.setUser(user);
      this.util.setToken(user.token);

      loading.dismiss();

      let picture = null;

      if (user.created_red_social) {
        /*this.navCtrl.push(RegisterPageTwo, {
          createdBySocial: true,
          user,
          name: user.name,
          profile_image: picture,
        });*/
      } else {
        setTimeout(() => {
          this.navCtrl.navigateRoot('workshops/' + this.worshopId);
          window.localStorage.setItem('louderbandToken', user.token);
        }, 300);
      }
    }, (error) => {
      console.error('error: ', error);
      loading.dismiss();
      // this.loadingModal(error.message);
    });

  }

  gotoLogin() {
    this.showModalLogin = false;
    const currentRoute = 'workshops/' + this.worshopId;
    localStorage.setItem('currentRoute', currentRoute);
    this.pendingPayLoginService.payAfterLogin(true);
    this.navCtrl.navigateForward('/login');
  }
  loginApple() {
    if (Capacitor.getPlatform() === 'web') {
      this.appleWeb();
    } else {
      this.appleApp();
    }
  }


  async appleWeb() {

    const provider = new OAuthProvider('apple.com');

    signInWithPopup(this.auth, provider).then((result: UserCredential) => {
      console.log(result);
      if (result) {
        this.helpApple(result.user);
      }
    });
  }

  async helpApple(response) {

    let params = {
      username: response.email,
      name: response.displayName,
      red_social: 'APPLE',
      id_usuario_red_social: response.uid,
      tokenApple: response.accessToken,
      email: response.email,
      respuesta: JSON.stringify(response),
      notification_id: '' //this.oneSignal.getPlayerId()
    };
    // alert(JSON.stringify(params));
    const loading = await this.loadingCtrl.create({
      message: ''
    });
    loading.present();
    this.rest._post('apple/login', params).subscribe(async (responseApple) => {
      const user: any = responseApple.body;
      this.util.setToken(user.token);
      this.rest.storageSet('user', user);
      loading.dismiss();
      let picture = null;

      if (user.created_red_social) {
        /*this.navCtrl.push(RegisterPageTwo, {
          createdBySocial: true,
          user,
          name: response.fullName.givenName + response.fullName.familyName,
          profile_image: picture,
        });*/
      } else {
        setTimeout(() => {
          this.navCtrl.navigateRoot('workshops/' + this.worshopId);
          window.localStorage.setItem('louderbandToken', user.token);
        }, 300);
      }
    }, (error) => {
      console.error('error: ', error);
      loading.dismiss();
      // this.loadingModal(error.message);
    });
  }

  async appleApp() {

    let options: SignInWithAppleOptions = {
      clientId: 'com.louderband.ios',
      redirectURI: 'https://louderband-app.firebaseapp.com/__/auth/handler',
      scopes: 'email name',
      state: '12345',
      nonce: 'nonce',
    };
    SignInWithApple.authorize(options)
      .then((result: SignInWithAppleResponse) => {
        // Handle user information
        // Validate token with server and create new session
        this.helpApple(result);
      })
      .catch(error => {
        // Handle error
      });
  }

  async getSubscriptions() {
    if (this.user) {
      let loading = await this.loadingCtrl.create({});
      loading.present();

      this.rest._get('subscription/purchased/list').subscribe(async (response) => {
        const res: any = response.body;
        this.userSubscriptions = res;

        console.log('userSubscriptions', res);
        loading.dismiss();

      }, (error) => {
        loading.dismiss();
        console.error('error subscriptions: ', error);
      });
    }

    this.getAvailableSubscriptions();
  }

  async loadProfile() {
    const loading = await this.loadingCtrl.create({});
    await loading.present();

    this.rest._get('accounts/user-information/' + this.user.user_id).subscribe(async (response) => {
      const res: any = response.body;
      this.profile = res;

      console.log('profile', res);
      await this.rest.storageSet('user', res);
      await loading.dismiss();

    }, async (error) => {
      await loading.dismiss();
      console.error('error', error);
    });
  }

  async gotoPromotion() {
    let toast = await this.toastCtrl.create({
      message: 'Ingresa al curso que deseas del listado debajo y luego presiona "¡Lo quiero!"',
      duration: 3000,
      position: 'middle'
    });

    await toast.present();
  }

  async gotoSharePromotion() {
    await Share.share({
      text: '¡Felices fiestas! Para empezar el año con todo, te regalo un curso de música a elección desde el sigiuente link: ' + 'https://louderband.com/cursos?type=2&promotion=' + this.promotion,
      dialogTitle: 'Comparte con tus amigos',
      title: 'Comparte con tus amigos',
    });
    this.trackingProvider.trackPromotionShare(AnalyticsType.GOOGLE_ANALYTICS);
    this.trackingProvider.trackPromotionShare(AnalyticsType.FACEBOOK_PIXEL);
  }
}


